import { Trans, useTranslation } from 'react-i18next';
import { Flex, Box, Button, Heading, Text, Separator } from '@radix-ui/themes';

import { BOTH, EMAIL, SMS } from '../utils/constants';

import { EmailPreview } from './Preview/EmailPreview.jsx';
import { BothPreview } from './Preview/BothPreview.jsx';
import { SmsPreview } from '../shared/SmsPreview.jsx';
import { Badge } from '../../../shared/Badge/Badge';
import { StatusBadge } from '../shared/StatusBadge.jsx';
import styles from './Summary.module.css';

export const Summary = ({
  values,
  sendTest,
  sendTestLabel,
  userCount,
  emailCount,
  smsCount,
  header,
  rightContent,
  status,
  audiences,
}) => {
  const { t } = useTranslation('broadcasts');

  const topNavCount = () => {
    switch (values.broadcastType) {
      case SMS:
        return smsCount;
      case EMAIL:
        return emailCount;
      default:
        return userCount;
    }
  };

  const subHeaderText = () => {
    switch (values.broadcastType) {
      case SMS:
      case EMAIL:
        return 'recipientCount';
      default:
        return 'audienceCount';
    }
  };

  return (
    <Box>
      <Flex
        px="5"
        py="3"
        justify="between"
        align="center"
        style={{ borderBottom: '1px solid var(--gray-a5)' }}
      >
        <Flex align="center" gap="4">
          <Heading size="5" m="0">
            {header}
          </Heading>
          <Badge variant="grey">
            <Trans>
              {t(`reviewStep.${subHeaderText()}`, { count: topNavCount() })}
            </Trans>
          </Badge>
          {audiences && audiences.length > 0 && (
            <>
              <Separator orientation="vertical" size="2" />
              <Flex align="center" gap="2">
                <Text size="2">{t('reviewStep.audiences')}:</Text>
                {audiences.map(audience => (
                  <span
                    className={styles.audienceBadge}
                    style={{ '--audience-color': audience.color }}
                    key={audience.value}
                    label={audience.label}
                  >
                    {audience.label}
                  </span>
                ))}
              </Flex>
            </>
          )}
        </Flex>
        <Flex align="center" gap="4">
          <StatusBadge status={status} />
          {rightContent}
          {sendTest && (
            <Button size="3" variant="outline" color="gray" onClick={sendTest}>
              {sendTestLabel || t('reviewStep.sendTestBtn')}
            </Button>
          )}
        </Flex>
      </Flex>
      {values.broadcastType === BOTH && (
        <BothPreview
          emailCount={emailCount}
          smsCount={smsCount}
          values={values}
        />
      )}
      {values.broadcastType === EMAIL && (
        <EmailPreview
          subject={values.subject}
          emailBody={values.emailBody}
          uuid={values.uuid}
        />
      )}
      {values.broadcastType === SMS && (
        <Box mb="6">
          <SmsPreview
            message={values.smsBody}
            title={values.smsTemplate}
            downloadable={Boolean(values.uuid)}
          />
        </Box>
      )}
    </Box>
  );
};
